// Workspace layout created by tools/gen_web_routes.py; owned by hand from here on.
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { meQuery } from '../../shared/org/me'
import { AppShell } from '../../shared/shell/AppShell'

export const Route = createFileRoute('/platform')({
  // Guard (platform staff): only a `/me` with `platform` gets in; everyone else renders NotFound, so the area cannot
  // be probed. The sign-in redirect stays with the session guard (spec 08 § 5).
  beforeLoad: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery())
    if (!me?.platform) throw notFound()
  },
  staticData: { workspace: 'platform' },
  component: () => (
    <AppShell workspace="platform">
      <Outlet />
    </AppShell>
  ),
})
